export default "__VITE_ASSET__c0fba75b__$_?component__"